import dayjs from 'dayjs';
import { DATE_STRING_TO_MOMENT } from 'utils/date';

const obtenerTipoDescarga = (value) => {
  if (value === 1) return 'Testigos';
  if (value === 2) return 'Sábanas';
  if (value === 3) return 'Todo';
  return 'Sábanas';
};

const obtenerNombreArchivo = (urlAlmacenamiento) => {
  const arreglo = urlAlmacenamiento.split('/');
  return arreglo[arreglo.length - 1];
};

export const adapterDownloadData = (downloads) => {
  const downloadsConFormato = downloads;
  downloadsConFormato.colaDescarga = downloadsConFormato.colaDescarga.map((download) => {
    return {
      ...download,
      fechaInicioPeticionFormat: dayjs(
        download.fechaInicioPeticion.toString(),
        DATE_STRING_TO_MOMENT
      ),
      fechaFinPeticionFormat: download.fechaFinPeticion
        ? dayjs(download.fechaFinPeticion.toString(), DATE_STRING_TO_MOMENT)
        : '',
      estatusDescripcion: download.estatus === 0 ? 'En Proceso' : 'Terminado',
      tipoDescargaDescripcion: obtenerTipoDescarga(download.tipoDescarga),
      nombreArchivo: obtenerNombreArchivo(download.urlAlmacenamiento)
    };
  });

  return downloadsConFormato;
};

export const adapterLinkData = (links) => {
  const linksConFormato = links;
  linksConFormato.colaEnlaces = linksConFormato.colaEnlaces.map((link) => {
    return {
      ...link,
      fechaInicioPeticionFormat: dayjs(link.fechaInicioPeticion.toString(), DATE_STRING_TO_MOMENT),
      fechaFinPeticionFormat: link.fechaFinPeticion
        ? dayjs(link.fechaFinPeticion.toString(), DATE_STRING_TO_MOMENT)
        : '',
      estatusDescripcion: link.estatus === 0 ? 'En Proceso' : 'Terminado',
      descripcion: link.descripcion,
      fechaVigenciaFormat: link.vigencia
        ? dayjs(link.vigencia.toString(), DATE_STRING_TO_MOMENT)
        : ''
    };
  });

  return linksConFormato;
};
